import { customSWRConfig } from '../../model/types';
import { getFieldInstanceFromTicket } from '../../utils/ticketHelper';
import useSingleCompanySetting from '../adminPage/useSingleCompanySetting';
import useCurrentTicket from './useCurrentTicket';

/**
 * @param {string} fieldKey - The key of the field that you want to check if authorization is required for.
 */
export default function useFieldAuthorization(fieldKey: string, config: customSWRConfig = {}) {
    const { data: singleCompanySetting, isLoading: isLoadingCompanySetting } = useSingleCompanySetting(
        fieldKey ? 'RESTRICTED_ASSIGNEE' : null,
        config
    );
    const { data: ticketDetail, isLoading: isLoadingTicket } = useCurrentTicket(config);

    let isAuthorizationRequired = false;

    if (fieldKey && singleCompanySetting?.value) {
        if (singleCompanySetting.value === fieldKey) {
            // given field-key points to the same fieldKey given in company-setting, render as disabled
            isAuthorizationRequired = true;
        } else if (ticketDetail) {
            // check if the field-key (passed in) is the same as the value of the field with the field-key given in the company settings
            const field = getFieldInstanceFromTicket(ticketDetail)(singleCompanySetting.value); // limitation => it should be text field

            if (field?.value) {
                isAuthorizationRequired = fieldKey === field.value;
            }
        }
    }

    return {
        isAuthorizationRequired,
        isLoading: isLoadingCompanySetting || isLoadingTicket
    };
}
